import { render, staticRenderFns } from "./ManufacturingOne.vue?vue&type=template&id=3e89e9ec"
import script from "./ManufacturingOne.vue?vue&type=script&lang=js"
export * from "./ManufacturingOne.vue?vue&type=script&lang=js"
import style0 from "./ManufacturingOne.vue?vue&type=style&index=0&id=3e89e9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports